
import React from 'react';
import { useLanguage } from "@/contexts/LanguageContext";

interface DurationHeaderProps {
  value: number;
}

const DurationHeader: React.FC<DurationHeaderProps> = ({ value }) => {
  const { language } = useLanguage();
  
  return (
    <div className={`flex justify-between items-center ${language === 'ar' ? 'flex-row-reverse' : ''}`}>
      <label className={`font-medium text-[#1A1F2C] ${language === 'ar' ? 'text-lg' : 'text-base'}`}>
        {language === 'ar' ? 'اختيار مدة الحملة' : "Choose your Campaign's Duration"}
      </label>
      <span className="text-sm font-bold text-black">
        {value || 0} {(value || 0) === 1 ? language === 'ar' ? 'يوم' : 'day' : language === 'ar' ? 'أيام' : 'days'}
      </span>
    </div>
  );
};

export default DurationHeader;
